// Simple debouce function that invokes a function after a certain amount of time has passed since the last invocation.
export function debounce<T extends (...args: any) => any>(
  func: T,
  wait: number,
): T {
  let timeout: NodeJS.Timeout | null;
  return function debounced(...args: Parameters<T>) {
    clearTimeout(timeout as NodeJS.Timeout);
    timeout = setTimeout(() => {
      timeout = null;
      // @ts-expect-error
      func(...args);
    }, wait);
  } as T;
}
